import { useForm } from 'react-hook-form';
import { Input } from '../shared/Input';
import { Button } from '../shared/Button';
import { WhatsAppIcon } from '../shared/icons';
import { DatosContacto } from '../../types/pedido';
import { validarContacto } from '../../validation/validators';

interface Props {
  onSubmit: (datos: DatosContacto) => void;
  enviando: boolean;
}

export function ContactForm({ onSubmit, enviando }: Props) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<DatosContacto>();

  const enviar = (datos: DatosContacto) => {
    const erroresManual = validarContacto(datos.nombre, datos.telefono);
    if (Object.keys(erroresManual).length > 0) return;
    onSubmit(datos);
  };

  return (
    <form
      onSubmit={handleSubmit(enviar)}
      data-testid="checkout-contact-form"
      className="flex flex-col gap-4 bg-surface border border-border rounded-xl p-6"
    >
      <Input
        label="Nombre completo"
        placeholder="Ej. María Torres"
        error={errors.nombre?.message}
        {...register('nombre', { required: 'El nombre es requerido' })}
      />
      <Input
        label="Teléfono"
        placeholder="Ej. 987 654 321"
        error={errors.telefono?.message}
        {...register('telefono', {
          required: 'El teléfono es requerido',
          pattern: { value: /^\d{7,}$/, message: 'Ingresa un teléfono válido (mínimo 7 dígitos)' },
        })}
      />
      <Button type="submit" disabled={enviando} data-testid="checkout-submit-button" className="mt-1.5">
        <WhatsAppIcon width={17} height={17} />
        {enviando ? 'Enviando…' : 'Confirmar y continuar a WhatsApp'}
      </Button>
    </form>
  );
}
